export class CondPagamento {
  public condPag?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
